<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">图片上传</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <!-- <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
        </span>
      </p> -->
      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>
    <div class="answer-images">
      <div
        v-for="(img, idx) in imageList"
        :key="'answer-' + idx"
        class="image-view"
      >
        <img :src="img" />
        <img
          src="@/assets/images/guanbi.png"
          class="delete"
          v-if="operate === 'answer'"
          @click.stop="handleDelete(index)"
        />
        <p class="fangda-box">查看图片</p>
      </div>
      <div
        v-if="imageList.length < pictureNum"
        class="image-view"
        @click="handleUpload"
      >
        <div class="plus-icon"></div>
        <p>上传图片</p>
        <p>最大10M</p>
      </div>
    </div>
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
    operate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      images: [],
      imageList: [],
      pictureNum: 0,
    };
  },
  methods: {
    handleUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          this.imageList.push(response.data.urls);
          this.dataObj.chooseList = JSON.stringify({
            list: this.imageList,
          });
          this.$emit(
            "update",
            JSON.stringify({
              data: this.dataObj,
              index: this.index,
              answer: {
                question_id: this.dataObj.id,
                type: this.dataObj.type,
                if_hide: this.dataObj.if_hide,
                answer: this.imageList,
              },
            }),
          );
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleDelete(index) {
      this.imageList.splice(index, 1);
      this.dataObj.chooseList = JSON.stringify({
        list: this.imageList,
      });
      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          index: this.index,
          answer: {
            question_id: this.dataObj.id,
            type: this.dataObj.type,
            if_hide: this.dataObj.if_hide,
            answer: this.imageList,
          },
        }),
      );
    },
  },
  watch: {
    params: {
      handler(newVal) {
        console.log("newVal帝企鹅一个群我也去我也放弃五月u去乌鸦", newVal);

        this.dataObj = newVal.data;
        this.index = newVal.index;
        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
        this.pictureNum = newVal.data.pictureNum || 0;

        this.imageList =
          JSON.parse(newVal.data.chooseList || '{"list":[]}').list || [];

        // if (newVal.answer && Array.isArray(newVal.answer.answer)) {
        //   this.imageList = newVal.answer.answer
        //     .map((item) => item.context)
        //     .filter(Boolean);
        // } else {
        //   this.imageList = [];
        // }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.answer-images {
  display: flex;
  align-items: center;
  gap: 10px;
}
.answer-images img {
  width: 154px;
  height: 154px;
  border-radius: 6px;
}

.image-view {
  width: 154px;
  height: 154px;
  background: #f4f4f4;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-bottom: 20px; */
  position: relative;
  cursor: pointer;

  .plus-icon {
    position: relative;
    width: 34px;
    height: 34px;
    margin-top: 30px;
    margin-bottom: 16px;
  }

  .plus-icon::before,
  .plus-icon::after {
    content: "";
    position: absolute;
    background-color: #b2b7bf;
  }

  .plus-icon::before {
    left: 50%;
    top: 0;
    width: 2px;
    height: 100%;
    transform: translateX(-50%);
  }

  .plus-icon::after {
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    transform: translateY(-50%);
  }

  span {
    font-size: 20px;
    font-weight: 400;
    color: #798497;
  }

  .delete {
    position: absolute;
    width: 25px;
    height: 25px;
    top: 6px;
    right: 6px;
  }
}

.fangda-box {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #3a60ff;
  color: #fff;
  font-size: 11px;
  padding: 2px 4px;
  /* border-radius: 10px 0; */
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewImage.vue